module.exports = __webpack_public_path__ + "img/home_img.95bed84d.png";